import { Component, Input } from '@angular/core';
import { SupportCard } from 'src/app/model/card/support-card';
import { config } from 'src/environments/environment';

import { documentToHtmlString } from '.';

declare var gtag: any;

@Component({
  selector: 'app-support-card',
  templateUrl: './support-card.component.html',
  styleUrls: ['./support-card.component.scss']
})
export class SupportCardComponent {
  @Input() supportCards: SupportCard[] = [];
  constructor() {}

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }

  handleButtonClick(buttonText: string, buttonUrl: string, event: Event): void {
    if (this.isBAPortalButton(buttonText)) {
      this.trackNavigation(buttonText, buttonUrl);
    }
  }

  private isBAPortalButton(buttonText: string): boolean {
    if (!buttonText) return false;
    return buttonText.trim().toLowerCase() === 'faqs';
  }

  private trackNavigation(buttonText: string, url: string): void {
    if (config.enableCookies && typeof gtag !== 'undefined') {
      gtag('event', 'ndc_agency_portalFAQ_link_click', {
        event_category: 'Support Card',
        event_label: buttonText,
        destination_url: url,
        transport_type: 'beacon'
      });
    }
  }
}
